export default "__VITE_PUBLIC_ASSET__23fe6af7__"